import { paramCase, pascalCase } from 'change-case'

const categories = [
  {
    name: 'Introduction',
    items: [
      { name: 'Home' },
      { name: 'Installation' }
    ]
  },
  {
    name: 'Styles',
    items: [
      { name: 'Breakpoints' },
      { name: 'Spacing' },
      { name: 'Colors' },
      { name: 'Text and Typography' }
    ]
  },
  {
    name: 'Form',
    items: [
      { name: 'Buttons' },
      { name: 'Checkboxes' },
      { name: 'Date Pickers' },
      { name: 'File Inputs' },
      { name: 'Radio Buttons' },
      { name: 'Selects' },
      { name: 'Switches' },
      { name: 'Textareas' },
      { name: 'Text Fields' }
    ]
  },
  {
    name: 'Components',
    items: [
      { name: 'Alerts' },
      { name: 'Chips' },
      { name: 'Dialogs' },
      { name: 'Expansion Panels' },
      { name: 'Icons' },
      { name: 'Menus' },
      { name: 'Overlays' },
      { name: 'Paginations' },
      { name: 'Skeleton loaders' },
      { name: 'Steppers' },
      { name: 'Tabs' },
      { name: 'Tooltips' }
    ]
  }
]

export default categories.map(category => {
  category.items.forEach(item => {
    item.path = '/' + (item.name === 'Home' ? '' : paramCase(item.name))
    item.componentName = pascalCase(item.name)
  })
  return category
})
